import { get, upperCase } from 'lodash/fp';

const FileExtNames = {
  png: 'Image',
  gif: 'Image',
  tif: 'Image',
  tiff: 'Image',
  jpeg: 'Image',
  jpg: 'Image',
  svg: 'Image',
  psd: 'Image',
  pdf: 'Document',
  doc: 'Document',
  docx: 'Document',
  xls: 'Spreadsheet',
  xlsx: 'Spreadsheet',
  ppt: 'PowerPoint',
  pptx: 'PowerPoint',
  txt: 'Text',
  mov: 'Video',
  avi: 'Video',
  mp4: 'Video',
  wmv: 'Video',
  avchd: 'Video',
  flv: 'Video',
  mp3: 'Audio',
  m4a: 'Audio',
  flac: 'Audio',
  wav: 'Audio',
  ogg: 'Audio',
  alac: 'Audio'
};

export default string => {
  const ext = string.split('.').pop();
  return get(ext, FileExtNames) || upperCase(ext);
};
